module.exports = __webpack_public_path__ + "img/29.8c928d2c.jpg";